import { buildFilterQueryBySearchFields } from "utils/general";

export const storagePlacesFilterToQuery = (q) => buildFilterQueryBySearchFields(q, ["address"]);
